import React, { useState, useEffect, useContext } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import { UserDataContext } from "../Contexts/UserDataContext";
import { invoiceStatusOptions, invoiceStatuses } from "../Mappings";
import { getWeekFromDate } from "../GlobalFunctions";
import ApproveRejectInvoice from "./ApproveRejectInvoice";
import { InvoiceDataContext } from "../Contexts/InvoiceDataContext";
import { AppStateContext } from "../Contexts/AppStateContext";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Chip from "@material-ui/core/Chip";
import CancelIcon from "@material-ui/icons/Cancel";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import _without from "lodash/without";

const axios = require("axios");

const useStyles = makeStyles((theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: 2,
      backgroundColor: "#FFF"
    },
    noLabel: {
      marginTop: theme.spacing(3)
    },
    tableHeader: {
      fontWeight: "bold",
    }, 
    menuList: {
      "& .MuiList-root": {
        flexDirection: "column",
      },
    }, 
  })
);



const InvoicePage = () => {
  const { userData } = useContext(UserDataContext);
  const {
    invoiceTableFilterText,
    setInvoiceTableFilterText,
    scrollToPosition,
  } = useContext(AppStateContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { invoiceData, setInvoiceData, invoiceDataModel } = useContext(InvoiceDataContext);
  const [count, setCount] = useState(0);
  const [tableRows, setTableRows] = useState([]);
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false); 

   const [selectedTrucksInvoice, setSelectedTrucksInvoice] = useState(
    JSON.parse(localStorage.getItem("selectedTrucksInvoice")) || ""
  );

  const [startDateInvoice, setStartDateInvoice] = useState(
    new Date(
      JSON.parse(localStorage.getItem("startDateInvoice")) ||
        new Date().getTime() - 7 * 24 * 60 * 60 * 1000
    )
  );

  const [endDateInvoice, setEndDateInvoice] = useState(
    new Date(JSON.parse(localStorage.getItem("endDateInvoice")) || new Date())
  );

  const [approvalStateInvoice, setApprovalStateInvoice] = useState(
    JSON.parse(localStorage.getItem("approvalStateInvoice")) || 0
  );

  const [userSearchedInvoice, setUserSearchedInvoice] = useState(
    JSON.parse(localStorage.getItem("userSearchedInvoice")) || false
  );

  const [shouldFetchInvoicesWithFilter, setShouldFetchInvoicesWithFilter] = useState(
    localStorage.getItem("selectedTrucksInvoice") ||
    localStorage.getItem("startDateInvoice") ||
    localStorage.getItem("endDateInvoice") ||
    localStorage.getItem("approvalStateInvoice")
  );

  useEffect(() => {
    localStorage.setItem("selectedTrucksInvoice", JSON.stringify(selectedTrucksInvoice));
  }, [selectedTrucksInvoice]);

  useEffect(() => {
    localStorage.setItem("startDateInvoice", JSON.stringify(startDateInvoice));
  }, [startDateInvoice]);

  useEffect(() => {
    localStorage.setItem("endDateInvoice", JSON.stringify(endDateInvoice));
  }, [endDateInvoice]);

  useEffect(() => {
    localStorage.setItem("approvalStateInvoice", JSON.stringify(approvalStateInvoice));
  }, [approvalStateInvoice]);

  useEffect(() => {
    localStorage.setItem("userSearchedInvoice", JSON.stringify(userSearchedInvoice));
  }, [userSearchedInvoice]);

  const displayColumns = [
    "id",
    "vendorTradingName",
    "netTotal",
    "startDate",
    "endDate",
    "truckId",
    "approvalState",
  ];

  useEffect(() => {
    scrollToPosition();
  }, [tableRows, scrollToPosition]);  


  useEffect(() => {
    if (shouldFetchInvoicesWithFilter && userSearchedInvoice) {
      fetchInvoicesWithFilter();
      setShouldFetchInvoicesWithFilter(false);
    }
  }, []);

  useEffect(() => {
    const reg = new RegExp(invoiceTableFilterText.toLowerCase());
    setTableRows(
      invoiceData.filter((invoice) => {
        const invoiceString = Object.keys(invoice).reduce(
          (acc, cur) => acc + " - " + String(invoice[cur]),
          String(invoiceStatuses[invoice.approvalState])
        );
        return reg.test(invoiceString.toLowerCase());
      })
    );
  }, [invoiceTableFilterText, invoiceData]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };


  const handleTruckChange = (event) => {
    setSelectedTrucksInvoice(event.target.value);
  };
  

  const handleStartDateChange = (date) => {
    setStartDateInvoice(date);
  };

  const handleEndDateChange = (date) => {
    setEndDateInvoice(date);
  };

  const handleApprovalStateChange = (event) => {
    setApprovalStateInvoice(event.target.value);
  };     


  const handleSearchButtonClick = async () => {
    if (selectedTrucksInvoice.length === 0) {
      setDialogOpen(true);
      return;
    }

    fetchInvoicesWithFilter();
  }

  const fetchInvoicesWithFilter = async () => {
    setUserSearchedInvoice(true); //this will tell us that the user tried to search invoice and we will auto load invoice page not unless he logs out

    const inputTruckId = isNaN(selectedTrucksInvoice) ? null : parseInt(selectedTrucksInvoice.toString().replace(/\D/g, ''));

    const searchFilters = {
      startDate: startDateInvoice ? startDateInvoice.toISOString() : null,
      endDate: endDateInvoice ? endDateInvoice.toISOString() : null,
      approvalState: approvalStateInvoice ? parseInt(approvalStateInvoice) : null,
      truckIds: inputTruckId ? [inputTruckId] : []
    };
    
    try {
      const response = await axios.post('/invoices/get-invoices-with-filters', searchFilters, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      });
      setInvoiceData(response.data);
      setCount(response.data.length);
    } catch (error) {
      console.error(error);
    }      
    
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleProceed = () => {
    setDialogOpen(false);
    fetchInvoicesWithFilter();
  };

  const handleKeyPress = (event) => {
    const pattern = /[0-9]/;
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="stretch"
      spacing={4}
    >
      <Grid item>
        <Typography variant="h3">Invoices</Typography>
      </Grid>

      {/* truckid, start, end , approval state filters */}
      <Grid item>
        <Grid container direction="row" justify="space-between" alignItems="center" spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
                id="truck-select"
                label="Truck ID"
                value={selectedTrucksInvoice}
                onChange={handleTruckChange}
                variant="outlined"
                margin="normal"
                fullWidth
                inputProps={{
                  inputMode: "numeric", // enable numeric keyboard on mobile devices
                  autoComplete: 'off'
                }}
                onKeyPress={handleKeyPress}
              />
          </Grid>

          <Grid item xs={12} sm={2}>
            <DatePicker
              autoOk
              label="Start Date"
              inputVariant="outlined"
              value={startDateInvoice}
              onChange={handleStartDateChange}     
              views={['year', 'month', 'date']}  
              format="dd-MM-yyyy"
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <DatePicker
              autoOk
              label="End Date"
              inputVariant="outlined"
              value={endDateInvoice}
              onChange={handleEndDateChange}
              views={['year', 'month', 'date']}
              format="dd-MM-yyyy"
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              label="Approval State"
              InputLabelProps={{ shrink: true }}
              select
              variant="outlined"
              value={approvalStateInvoice}
              onChange={handleApprovalStateChange}
            >
              <MenuItem value="0">All</MenuItem>
              {invoiceStatusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button variant="contained" color="primary" size="large" onClick={handleSearchButtonClick}>        
              Search
            </Button>
          </Grid>

          <Dialog
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"No truck id entered."}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                  Warning: No truck id have been entered. This may result in a large number of invoices being returned, which could cause slow performance on your browser. Are you sure you want to proceed?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={handleProceed} autoFocus>Proceed</Button>
            </DialogActions>
          </Dialog>
          
        </Grid>
      </Grid>

      {/* END - truckid, start, end , approval state filters */}
      
      <Grid item>
        <TextField
          fullWidth
          name="filter"
          placeholder="Search Invoices..."
          variant="outlined"
          value={invoiceTableFilterText}
          onChange={(event) => setInvoiceTableFilterText(event.target.value)}
        />
      </Grid>    

      <Grid item>
        <Table>
          <TableHead>
            <TableRow>
              {displayColumns.map((col) => (
                <TableCell key={col} className={classes.tableHeader}>
                  {invoiceDataModel[col].displayName}
                </TableCell>
              ))}
              <TableCell className={classes.tableHeader}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((invoice) => {
              const invoiceStarteDate = invoice.startDate.split("T")[0];
              const week = getWeekFromDate(invoiceStarteDate);
              const truckId = invoice.truckId;
              const invoiceId = invoice.id;
              return (
                <TableRow key={invoice.id}>
                  {displayColumns.map((col) => (
                    <TableCell key={col}>
                      {invoiceDataModel[col].displayValue(invoice[col])}
                    </TableCell>
                  ))}
                  <TableCell>
                    <ApproveRejectInvoice
                      truckId={truckId}
                      week={week}
                      invoiceId={invoiceId}
                      invoice={invoice}
                    />
                    {/* {userData.roleId === roles.tollAdmin && invoice.approvalState !== invoiceStatuses.adminApproved && (
                      <ApproveRejectInvoice truckId={truckId} week={week} invoiceId={invoiceId} />
                    )}
                    {userData.roleId === roles.tollManager &&
                      invoice.approvalState === invoiceStatuses.adminApproved && (
                        <ApproveRejectInvoice truckId={truckId} week={week} invoiceId={invoiceId} />
                      )}
                    {userData.roleId === roles.ownerDriver && (
                      <Tooltip title="View DPC data">
                        <IconButton
                          onClick={() => history.push(`/${userData.userName}/trucks/${truckId}/weeks/${week}`)}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>
                    )} */}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          onChangePage={(event, newPage) => handlePageChange(event, newPage)}
          onChangeRowsPerPage={(event) => handleRowsPerPageChange(event)}
        ></TablePagination>
      </Grid>
    </Grid>
    </MuiPickersUtilsProvider>
  );
};

export default InvoicePage;
